export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_TWO_FACTOR_REQUEST = 'GET_TWO_FACTOR_REQUEST'
